/** Единый опрос онбординга: одни ответы → критерии победы и поисковый ключ. */
export const ONBOARDING_QUIZ_ITEMS = [
  {
    id: 'profile',
    question: 'Кратко опишите ваш профиль участия в закупках (роль, отрасли, типичный размер контрактов).',
    placeholder: 'Например: поставщик IT-оборудования, 44-ФЗ, контракты до 5 млн ₽',
  },
  {
    id: 'priorities',
    question: 'Что для вас важнее всего при оценке шанса победы?',
    placeholder: 'Цена, соответствие ТЗ, опыт и референсы, сроки поставки, гарантии, локализация…',
  },
  {
    id: 'pain',
    question: 'На каких требованиях заказчика вы чаще всего «теряете» тендеры?',
    placeholder: 'Жёсткие квалификации, обеспечение заявки, субподряд, сертификаты…',
  },
  {
    id: 'must_check',
    question: 'Какие пункты вы всегда проверяете в документации до подачи заявки?',
    placeholder: 'Состав заявки, критерии оценки, штрафы, сроки исполнения…',
  },
  {
    id: 'extra',
    question: 'Дополнительно: пожелания к критериям победы и к поиску тендеров.',
    placeholder: 'Необязательно',
    optional: true,
  },
]

export const WIN_CRITERIA_QUIZ_ITEMS = ONBOARDING_QUIZ_ITEMS

/** Текстовые вопросы поискового ключа в продуктовом онбординге. */
export const ONBOARDING_KEY_QUIZ_ITEMS = [
  {
    id: 'keywords',
    question: 'Ключевые слова — что искать в закупках?',
    placeholder: 'Предмет закупки, товары, услуги, работы, типовые формулировки из извещений…',
  },
  {
    id: 'exclusions',
    question: 'Исключения — что не должно попадать в выдачу?',
    placeholder: 'Нерелевантные темы, лишние формулировки, смежные направления…',
    optional: true,
  },
]

export const ONBOARDING_ALL_QUIZ_ITEMS = [...ONBOARDING_QUIZ_ITEMS, ...ONBOARDING_KEY_QUIZ_ITEMS]

/** Короткий опрос только в KeyModal (не онбординг). */
export const SEARCH_KEY_QUIZ_ITEMS = ONBOARDING_KEY_QUIZ_ITEMS